<template>
    <j-page class="j-tools-layout">
        <div slot="table">
            <el-card shadow="hover">
                <label slot="header">通过generateName获取文件服务资源地址</label>
                <el-divider content-position="left">$jtool.oss.getUrlByGenerateName('base-template_grid_2022-10-12-10-10-02_JUpload/ca8adf1ca38845f7a5ec320417ae1980.png')</el-divider>
                <p class="result">{{$jtool.oss.getUrlByGenerateName('base-template_grid_2022-10-12-10-10-02_JUpload/ca8adf1ca38845f7a5ec320417ae1980.png')}}</p>
                <img height="50" width="50" :src="$jtool.oss.getUrlByGenerateName('base-template_grid_2022-10-12-10-10-02_JUpload/ca8adf1ca38845f7a5ec320417ae1980.png')" alt="">
            </el-card>

            <el-card shadow="hover">
                <label slot="header">文件单位转换工具（根据文件大小自动生成单位后缀）</label>
                <el-divider content-position="left">fileSizeOfTool(limit = 0, fixed = 2, unitLimit = '') 传参limit为初始值, fixed为小数点省略，单位自动计算</el-divider>
                fileSizeOfTool(224893)
                <span class="result">{{$jtool.file.fileSizeOfTool(224893)}}</span>
                <el-divider content-position="left">unitLimit限制固定单位</el-divider>
                fileSizeOfTool(224893, 3, 'kb')
                <span class="result">{{$jtool.file.fileSizeOfTool(224893, 2, 'kb')}}</span>
            </el-card>

            <el-card shadow="hover">
                <label slot="header">颜色值转换</label>
                <el-divider content-position="left">$jtool.color.HexToRgb('#97C5EF')</el-divider>
                <span class="result">{{$jtool.color.HexToRgb('#97C5EF')}}</span>
            </el-card>

            <el-card shadow="hover">
                <label slot="header">根据身份证号自动带出基本信息</label>
                <el-divider content-position="left">$jtool.people.getPeopleBaseByCardCode('110101199003078478')</el-divider>
                <span class="result">{{$jtool.people.getPeopleBaseByCardCode('110101199003078478')}}</span>
            </el-card>

            <el-card shadow="hover">
                <label slot="header">校验方法</label>
                <el-divider content-position="left">手机号：$jtool.validate.checkPhone</el-divider>
                <el-divider content-position="left">电子邮箱：$jtool.validate.checkEmail</el-divider>
                <el-divider content-position="left">移动电话/座机/手机号码（三合一）：$jtool.validate.checkTel</el-divider>
                <el-divider content-position="left">身份证号：$jtool.validate.checkIdCard</el-divider>
                <el-divider content-position="left">统一社会信用代码：$jtool.validate.checkSocietyCreditCode</el-divider>
                <el-divider content-position="left">护照(包括香港澳门)：$jtool.validate.checkPassport</el-divider>
                <el-divider content-position="left">银行卡号：$jtool.validate.checkBankCard</el-divider>
                <el-divider content-position="left">车牌号：$jtool.validate.checkCarNo</el-divider>
            </el-card>
        </div>
    </j-page>
</template>

<script>
    import PageMixins from "../../components/JComponents/JPage/mixins/PageMixins";
    export default {
        name: "JToolDemo",
        mixins: [PageMixins]
    }
</script>

<style lang="scss">
    .j-tools-layout {
        position: relative;
        height: 100%;
        box-sizing: border-box;
        padding: 15px;
        overflow-y: auto;
        .el-card {
            position: relative;
            margin-bottom: 50px;
        }
        .result {
            color: #409EFF;
        }
    }
</style>
